import React from 'react';
import { TouchableOpacity } from 'react-native';
import { LuxSurfaceKeys, } from '@alucio/lux-ui/src/typings';
import { FalsyText } from '@ui-kitten/components/devsupport';
import styled from '@alucio/lux-ui/src/theming/util/styled';
import DNAIcon from '@alucio/lux-ui/src/components/visual/DNAIcon/DNAIcon';
import DNABox from '@alucio/lux-ui/src/components/layout/DNABox/DNABox';
import Iffy from '@alucio/lux-ui/src/components/util/Iffy/Iffy';
export var DNAChipAppearanceEnum;
(function (DNAChipAppearanceEnum) {
    DNAChipAppearanceEnum["tag"] = "tag";
})(DNAChipAppearanceEnum || (DNAChipAppearanceEnum = {}));
export const DNAChipAppearanceKeys = [
    ...LuxSurfaceKeys,
    ...Object.keys(DNAChipAppearanceEnum),
];
function parseComponentStyle(source) {
    const { textFontSize, textFontWeight, textMarginHorizontal, textMarginVertical, textColor, iconColor, iconHeight, iconWidth, iconName, iconMarginHorizontal, iconMarginVertical, iconMarginRight, ...container } = source;
    return {
        container,
        textStyle: {
            color: textColor,
            fontSize: textFontSize,
            fontWeight: textFontWeight,
            marginHorizontal: textMarginHorizontal,
            marginBottom: textMarginVertical,
        },
        iconStyle: {
            alignSelf: 'center',
            color: iconColor,
            height: iconHeight,
            width: iconWidth,
            marginRight: iconMarginRight,
        },
        iconName,
    };
}
/** [TODO]: Consider re-using as Box? */
const DNAChip = (props) => {
    const { eva, style, children, onClose, testID } = props;
    const { container, textStyle, iconStyle, iconName } = parseComponentStyle(eva.style);
    return (<DNABox testID={testID} alignY="center" style={[container, style]}>
      <Iffy is={onClose}>
        <TouchableOpacity testID="chip-close" onPress={onClose} activeOpacity={1}>
          <DNAIcon name={iconName} style={iconStyle}/>
        </TouchableOpacity>
      </Iffy>
      <FalsyText testID="chip-text" style={textStyle} component={children}/>
    </DNABox>);
};
export default styled('DNAChip')(DNAChip);
//# sourceMappingURL=DNAChip.js.map